import { X, Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const saas = [
    "Você instala e configura",
    "Você aprende a plataforma",
    "Você resolve quando trava",
    "Respostas robóticas e engessadas",
    "Suporte por ticket",
];

const degasperin = [
    "Eu implemento tudo pra você em até 10 dias",
    "Você não muda nada no seu dia a dia",
    "Agente personalizado com a linguagem do seu negócio",
    "IA real que não trava, não repete script, se adapta",
    "Atendimento direto comigo",
];

export const Difference = () => {
    return (
        <section id="diferenca" className="relative py-24 md:py-32 lg:py-40">
            <div className="absolute inset-0 dg-grid opacity-20" />
            <div className="relative max-w-6xl mx-auto px-6 md:px-12">
                <Reveal>
                    <p className="text-sm md:text-base font-semibold uppercase tracking-widest text-[#94B4FF]">
                        A diferença
                    </p>
                    <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#F5F5F5] max-w-3xl">
                        Não é mais uma plataforma pra você aprender no fim de semana
                    </h2>
                    <p className="mt-6 text-base lg:text-lg text-[#F5F5F5]/70 leading-relaxed max-w-3xl">
                        Toda solução por aí entrega uma ferramenta. Você instala,
                        configura, aprende e resolve quando trava — no seu tempo livre,
                        que você não tem. Aqui é diferente:{" "}
                        <span className="text-[#F5F5F5]">eu implemento tudo pra você.</span>{" "}
                        Você continua atendendo do jeito que sempre atendeu — só que agora
                        tem um agente de IA fazendo o resto enquanto você trabalha.
                    </p>
                </Reveal>

                <div className="mt-14 grid md:grid-cols-2 gap-6 md:gap-8">
                    <Reveal>
                        <div
                            data-testid="difference-saas"
                            className="h-full rounded-2xl border border-[#1E1E28] bg-[#0E0E13] p-8 opacity-80"
                        >
                            <h3 className="font-display text-lg font-semibold text-[#7A7A90]">
                                Software SaaS genérico
                            </h3>
                            <ul className="mt-6 space-y-4">
                                {saas.map((item) => (
                                    <li
                                        key={item}
                                        className="flex items-start gap-3 text-[#7A7A90]"
                                    >
                                        <span className="mt-0.5 flex-shrink-0 rounded-full border border-[#2a2a36] p-1">
                                            <X className="w-3.5 h-3.5" />
                                        </span>
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </Reveal>

                    <Reveal delay={0.12}>
                        <div
                            data-testid="difference-degasperin"
                            className="relative h-full rounded-2xl border border-[#3B6FFF]/50 bg-gradient-to-b from-[#141B33] to-[#121218] p-8 shadow-[0_0_50px_rgba(59,111,255,0.18)]"
                        >
                            <div className="absolute top-6 right-6 rounded-full bg-[#3B6FFF]/15 px-3 py-1 text-xs font-semibold text-[#94B4FF]">
                                Recomendado
                            </div>
                            <h3 className="font-display text-lg font-semibold text-[#F5F5F5]">
                                Degasperin IA
                            </h3>
                            <ul className="mt-6 space-y-4">
                                {degasperin.map((item) => (
                                    <li
                                        key={item}
                                        className="flex items-start gap-3 text-[#F5F5F5]"
                                    >
                                        <span className="mt-0.5 flex-shrink-0 rounded-full bg-[#3B6FFF] p-1 text-white">
                                            <Check className="w-3.5 h-3.5" />
                                        </span>
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
};

export default Difference;
